// import { take, call, put, select } from 'redux-saga/effects';

// Individual exports for testing
import { put, select, takeLatest } from 'redux-saga/effects';
import { makeSelectSettings } from 'containers/SettingsProvider/selectors';
import { lookup } from 'utils/geocode';
import { geoSearchFound, geoSelect } from './actions';
import { GEO_SEARCH } from './constants';
import mapSearchresults, { mapCoordinates } from './mapSearchResults';
import asCoordinates from './asCoordinates';

export function* geoSearch(action) {
  const { search } = action;
  const locale = yield select(makeSelectSettings(['locale'])());
  const results = yield lookup(search, locale);
  const filtered = mapSearchresults(results);
  const coordinates = asCoordinates(search.q);
  if (coordinates) {
    filtered.unshift(mapCoordinates(coordinates));
  }
  yield put(geoSearchFound(filtered));
  if (filtered.length > 0) {
    yield put(geoSelect(filtered[0]));
  }
}

export default function* defaultSaga() {
  yield takeLatest(GEO_SEARCH, geoSearch);
}
